import { Theme } from '@metadevprofile/shared';
import { useEffect } from 'react';
import { useAppSelector } from '@/common/redux/store';
import { selectTheme } from '@/profile/stores/preferences-slice';

export function useThemeManager() {
  const theme = useAppSelector(selectTheme);

  useEffect(() => {
    const applyTheme = () => {
      const html = document.documentElement;

      const isDark =
        theme === Theme.DARK || (theme === Theme.SYSTEM && window.matchMedia('(prefers-color-scheme: dark)').matches);

      html.classList.toggle('dark', isDark);
      html.dataset.theme = isDark ? 'dark' : 'light';
    };

    applyTheme();

    if (theme === Theme.SYSTEM) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      mediaQuery.addEventListener('change', applyTheme);

      return () => {
        mediaQuery.removeEventListener('change', applyTheme);
      };
    }
  }, [theme]);

  return {
    theme,
    isDarkMode:
      theme === Theme.DARK || (theme === Theme.SYSTEM && window.matchMedia('(prefers-color-scheme: dark)').matches),
  };
}
